import React, { useEffect, useState } from "react";
import { Button } from "@heroui/button";
import { Spinner } from "@heroui/spinner";
import { Pagination } from "@heroui/pagination";

import { getOldResearchReports } from "@/src/app/hooks/content.hooks";

const PDFGrid = ({ companyId, isCompanyPrivate }) => {
  const [postData, setPostData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [sort, setSort] = useState("desc");
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 3;

  useEffect(() => {
    const fetchCompanyOldReports = async () => {
      setIsLoading(true);
      try {
        let response;
        if (!isCompanyPrivate) {       
          response = await getOldResearchReports(
            currentPage,
            itemsPerPage,
            sort,
            companyId,
            isCompanyPrivate
          );
        } else {
          response = await getOldResearchReports(
            currentPage,
            itemsPerPage,
            sort,
            "",
            isCompanyPrivate,
            companyId
          );
        }

        if (response.status === 200) {
          setPostData(response.data.data);
          setTotalPages(response.data.pagination.last_page);
        } else {
          setPostData([]);
          setTotalPages(0);
        }
      } catch (error) {
        setPostData([]);
        setTotalPages(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanyOldReports();
  }, [companyId, currentPage, sort, isCompanyPrivate]); // Include isCompanyPrivate here

  return (
    <section className="mt-5 bg-white">
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          {/* Replace this div with an actual spinner or CircularProgress component */}
          <div className="flex justify-center items-center h-full">
            <Spinner color="primary" />
          </div>
        </div>
      ) : postData.length > 0 ? (
        <ul className="space-y-4">
          {postData.map((post) => (
            <li
              key={post.id}
              className="flex justify-between items-center bg-white p-4 border-b"
            >
              <div className="flex-1">
                <h3 className="text-lg font-semibold cursor-pointer hover:underline">
                  {post.title}
                </h3>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">
                    Published at:{" "}
                    {new Date(post.report_date).toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>
              </div>
              <Button
                className="ml-4 bg-1B51CA text-white"
                onClick={() => downloadPDF(post.url)}
              >
                Download PDF
              </Button>
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex justify-center items-center text-center mx-auto w-full min-h-[20rem] -mt-8">
          <span className="text-xl text-gray-500">
            No Research Reports Found
          </span>
        </div>
      )}
      {totalPages > 1 && (
        <div className="flex justify-center mt-5">
          <Pagination
            loop
            showControls
            color="success"
            total={totalPages}
            initialPage={1}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}
    </section>
  );
};

export default PDFGrid;

// Function to handle downloading of PDF
const downloadPDF = (pdfUrl) => {
  if (!pdfUrl) {
    console.error("PDF URL is missing");
    return;
  }

  const link = document.createElement("a");
  link.href = pdfUrl;
  link.target = "_blank";
  link.rel = "noopener noreferrer";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
